import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  FieldHeader,
  FieldBody,
} from 'web-ui-components/lib/molecules/forms';
import { Input } from 'web-ui-components/lib/atoms/forms';

export const InputField = ({
  name,
  title,
  value,
  validationMessage,
  onChange,
  onFieldBlur,
  maxLength,
  size,
}) => (
  <Field>
    <FieldHeader
      name={name}
      title={title}
      validationMessage={validationMessage}
      hasError={!!validationMessage}
    />
    <FieldBody>
      <Input
        id={name}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        size={size}
        onBlur={(e) => onFieldBlur(e)}
      />
    </FieldBody>
  </Field>
);

InputField.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  validationMessage: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
